import * as React from 'react';
import {Card,Box , Typography } from '@mui/material';

export default function PaymentExpiredPage()
{
    return (
        <>
            <Box textAlign="left">
                <Typography variant="h2" gutterBottom>Thank you</Typography>
                <Typography variant="h6" gutterBottom>Your payment link has expired.</Typography>
            </Box>

            <Card>
                <Box p={5} textAlign="center">
                    <p>
                        If you believe there has been an error please do not hesistate to contact us.
                    </p>
                </Box>
            </Card>
        </>
    )
}